import React from 'react'
import { ManageRatesBilling } from "../../../app/modules/eMPower/pages/ManagerRatesXW/CustomersPage";

export function ManageRatesPage() {
    return (
        <ManageRatesBilling />
    )
}